'use client';

import 'photoswipe/dist/photoswipe.css';
import type { GalleryImage } from '@/types/custom';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import type { LegacyRef } from 'react';

// Dynamically import the PhotoSwipe components with ssr disabled
const PhotoSwipeGallery = dynamic(
    () => import('react-photoswipe-gallery').then((mod) => mod.Gallery),
    { ssr: false }
);

const PhotoSwipeItem = dynamic(() => import('react-photoswipe-gallery').then((mod) => mod.Item), {
    ssr: false,
});

interface GalleryProps {
    images: GalleryImage[];
}

export default function Gallery({ images }: GalleryProps) {
    return (
        <PhotoSwipeGallery
            id="gallery"
            withCaption
            options={{
                zoom: false,
                wheelToZoom: true,
                initialZoomLevel: 'fit',
                secondaryZoomLevel: 'fit',
                maxZoomLevel: 'fit',
                imageClickAction: 'close',
                bgClickAction: 'close',
            }}
        >
            {images.map((image) => (
                <PhotoSwipeItem
                    id={`photo${image.id}`}
                    key={`photo${image.id}`}
                    original={image.url}
                    thumbnail={image.url}
                    width={image.width}
                    height={image.height}
                    caption={image.title}
                >
                    {({ ref, open }) => (
                        <button
                            type="button"
                            ref={ref as LegacyRef<HTMLButtonElement>}
                            onClick={open}
                            className={'cursor-pointer'}
                        >
                            <Image
                                src={image.url}
                                width={image.width}
                                height={image.height}
                                alt={image.title}
                                style={{
                                    maxWidth: '100%',
                                    height: 'auto',
                                }}
                            />
                            <div className={'mt-3 block font-neue-haas text-haug-ivory-30'}>
                                {image.title}
                            </div>
                        </button>
                    )}
                </PhotoSwipeItem>
            ))}
        </PhotoSwipeGallery>
    );
}
